import {BeforePseudoIconBorder} from 'accessibility/focusStyles'
import classnames from 'classnames'
import Close from 'components/lib/icons/Close'
import NakedButton from 'components/lib/NakedButton'
import useKeyboardNavigation from 'hooks/useKeyboardNavigation'
import useThemeColors from 'hooks/useThemeColors'
import useWidgetAlignment from 'hooks/useWidgetAlignment'
import React, { useRef } from 'react'

import './style.css'

interface MessageCloseButtonProps {
  onClick: (event: any) => void
}

const MessageCloseButton = ({ onClick }: MessageCloseButtonProps) => {
  const widgetAlignment = useWidgetAlignment()
  const themeColors = useThemeColors()
  const closeButtonRef = useRef(null)

  const isbuttonKeyboardFocused = useKeyboardNavigation(closeButtonRef)

  return (
    <>
      <style>
        {`.drift-widget-message-close-button.keyboard-focused {
          opacity: 1;
        }
        .drift-widget-message-close-button.keyboard-focused:before {
          ${BeforePseudoIconBorder(themeColors.activeColor,20, -3, -3)}
        }
        `}
      </style>
      <NakedButton onClick={onClick}
        ref={closeButtonRef}
        className={classnames('drift-widget-message-close-button',
          `drift-widget-close-button--align-${widgetAlignment}`,{
            'keyboard-focused':isbuttonKeyboardFocused
          })}
        aria-label="close">
        <Close width={10} height={10} />
      </NakedButton>
    </>
  )
}

export default MessageCloseButton
